import { Alert, Avatar, Box, Button, Card, CircularProgress, Grid, IconButton, InputAdornment, Snackbar, TextField, Typography, useTheme } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { authActions } from "../../store/reducer/auth-reducer";
import { Link, useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import AlertBar from "../../components/AlertBar";
import { homePageActions } from "../../store/reducer/home";
import { AccountCircle, Lock, LockOpen, Password, PasswordOutlined } from "@mui/icons-material";
import { ReactComponent as Logo } from '../../assets/logo.svg';
import CmmKolkataLogo from "../../components/CmmKolkataLogo";
const defLogin: any = { app_key: "@34Y@#8deepmatka", mobile: '', password: '' }

const Login = ({ isAuthenticated, isPageLoading, userData, isLoginFailed, pageMessage, isLoginSuccess }: any) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [loginData, setLoginData] = useState<any>(defLogin)

    useEffect(() => {
        const pay: any = {
            menuname: 'starline'
        }
        dispatch(homePageActions.selectedMenu(pay))
    }, [])

    const handleOnChange = (event: any) => {
        setLoginData((prev: any) => {
            return { ...prev, [event.target.name]: event.target.value }
        })
    }
    const handleLogin = (event: any) => {
        event.stopPropagation();
        if (loginData.mobile.trim().length === 0) {
            setErrorMessage({ status: true, message: "Please enter valid userid or mobile number", severity: 'warning', inputName: 'mobile' })
        } else if (loginData.password.trim().length === 0) {
            setErrorMessage({ status: true, message: "Please enter valid password", severity: 'warning', inputName: 'password' })
        } else {
            setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
            dispatch(authActions.checkLogin(loginData))
        }
    }

    useEffect(() => {
        if (isAuthenticated) {
            localStorage.setItem('isAuthenticated', isAuthenticated);
            localStorage.setItem('userData', JSON.stringify(userData));
            const data: any = { "app_key": "@34Y@#8deepmatka", "user_id": userData.user_id }
            dispatch(authActions.getUserDataReq(data))
            dispatch(authActions.getWalletBalanceReq(data))
            navigate('/home')
        } else {
            if (localStorage.getItem('isAuthenticated')) {
                navigate('/home')
                const data: any = { "app_key": "@34Y@#8deepmatka", "user_id": userData.user_id }
                dispatch(authActions.getUserDataReq(data))
                dispatch(authActions.getWalletBalanceReq(data))
            } else {
                navigate('/login')
            }
        }
    }, [isAuthenticated])

    useEffect(() => {

        if (isLoginSuccess) {
            setLoginData(defLogin)
            setErrorMessage({ status: true, message: pageMessage, severity: 'success', inputName: '' })
        }

        if (isLoginFailed) {
            setLoginData(defLogin)
            setErrorMessage({ status: true, message: pageMessage, severity: 'warning', inputName: '' })
        }

    }, [isLoginSuccess, isLoginFailed])

    console.log('logindata', loginData)

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    const gotoRegister = () => {
        navigate('/register')
    }

    return (    
        <Grid container sx={{backgroundColor: theme.palette.background.default, marginTop:'80px'}} >
            <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
            <Grid xs={12} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                 <Box sx={{ marginBottom: '30px', marginTop: '20px' }}>
                    <CmmKolkataLogo style={{ transform: 'scale(1.5)' }} />
                 </Box>
                <Card sx={{ 
                    display: 'flex', 
                    boxShadow: theme.shadows[6], 
                    border: `2px solid ${theme.palette.divider}`, 
                    flexDirection: 'column', 
                    alignItems: "center", 
                    justifyContent: 'center', 
                    gap: 2, 
                    padding: '40px',
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: '24px',
                }}>
                <Box>
                    <Avatar sx={{
                        width:'100px', 
                        height:'100px',
                        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                    }}/>
                </Box>
                
                <Typography sx={{
                    fontSize:'24px', 
                    fontWeight: 700,
                    color: theme.palette.text.primary,
                    fontFamily: 'Poppins',
                }}>Login</Typography>

                {/* New User Message */}
                <Box sx={{
                    width: '100%',
                    padding: '16px',
                    borderRadius: '12px',
                    backgroundColor: theme.palette.mode === 'light' 
                        ? 'rgba(74, 144, 226, 0.1)' 
                        : 'rgba(74, 144, 226, 0.15)',
                    border: `1px solid ${theme.palette.primary.light}`,
                    marginBottom: '10px',
                }}>
                    <Typography sx={{
                        fontSize: '0.95rem',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        color: theme.palette.text.primary,
                        lineHeight: 1.6,
                        textAlign: 'center',
                    }}>
                        <strong style={{ color: theme.palette.primary.main }}>New User? / नए उपयोगकर्ता?</strong>
                        <br />
                        <span style={{ fontSize: '0.9rem' }}>
                            If you are visiting this app for the first time, please register first to create your account.
                        </span>
                        <br />
                        <span style={{ fontSize: '0.9rem' }}>
                            यदि आप पहली बार इस ऐप पर आ रहे हैं, तो कृपया पहले अपना खाता बनाने के लिए रजिस्टर करें।
                        </span>
                    </Typography>
                </Box>
                    <TextField InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <AccountCircle sx={{ color: theme.palette.primary.main }} />
                            </InputAdornment>
                        )
                    }} sx={{ 
                        width: "100%",
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: theme.palette.divider,
                            },
                            '&:hover fieldset': {
                                borderColor: theme.palette.primary.main,
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: theme.palette.primary.main,
                            },
                        },
                    }} placeholder="Mobile Number" name="mobile" variant="outlined" value={loginData.mobile} type="text" error={(errorMessage.inputName === 'mobile') ? errorMessage.status ? errorMessage.message : '' : ''} helperText={(errorMessage.inputName === 'mobile') ? errorMessage.status ? errorMessage.message : '' : ''} onChange={handleOnChange} />
                    <TextField InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LockOpen sx={{ color: theme.palette.primary.main }} />
                            </InputAdornment>
                        )
                    }}sx={{ 
                        width: "100%",
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: theme.palette.divider,
                            },
                            '&:hover fieldset': {
                                borderColor: theme.palette.primary.main,
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: theme.palette.primary.main,
                            },
                        },
                    }} placeholder="Password" name="password" variant="outlined" value={loginData.password} type="password" error={(errorMessage.inputName === 'password') ? errorMessage.status ? errorMessage.message : '' : ''} helperText={(errorMessage.inputName === 'password') ? errorMessage.status ? errorMessage.message : '' : ''} onChange={handleOnChange} />
                    <Button variant="contained" sx={{ 
                        width: "100%", 
                        boxShadow: theme.shadows[4], 
                        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                        color: '#FFFFFF',
                        fontWeight: 600,
                        fontSize: '1rem',
                        padding: '12px',
                        '&:hover': { 
                            boxShadow: theme.shadows[6],
                            transform: 'translateY(-2px)',
                        },
                        transition: 'all 0.3s ease',
                    }} onClick={handleLogin}>Login</Button>
                    {isPageLoading && <CircularProgress sx={{ color: theme.palette.primary.main }} />}
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 1,
                    }}>
                        <Typography sx={{ 
                            width: "100%", 
                            color: theme.palette.text.secondary, 
                            textAlign: 'center',
                            fontSize: '0.9rem',
                            fontFamily: 'Poppins',
                            marginBottom: '8px',
                        }}>
                            Don't have an account? / खाता नहीं है?
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={gotoRegister}
                            sx={{
                                width: '100%',
                                background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.warning.main} 100%)`,
                                color: '#FFFFFF',
                                fontWeight: 700,
                                fontSize: '1rem',
                                fontFamily: 'Poppins',
                                padding: '12px 24px',
                                borderRadius: '12px',
                                boxShadow: `0 4px 15px rgba(82, 201, 162, 0.4)`,
                                textTransform: 'none',
                                '&:hover': {
                                    background: `linear-gradient(135deg, ${theme.palette.success.dark} 0%, ${theme.palette.warning.dark} 100%)`,
                                    transform: 'translateY(-2px)',
                                    boxShadow: `0 6px 20px rgba(82, 201, 162, 0.5)`,
                                },
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                animation: 'pulse 2s infinite',
                                '@keyframes pulse': {
                                    '0%, 100%': {
                                        boxShadow: `0 4px 15px rgba(82, 201, 162, 0.4)`,
                                    },
                                    '50%': {
                                        boxShadow: `0 4px 20px rgba(82, 201, 162, 0.6)`,
                                    },
                                },
                            }}
                        >
                            Create New Account / नया खाता बनाएं
                        </Button>
                    </Box>
                </Card>
            </Grid>            
        </Grid>        
    )
}



const mapStateToProps = (state: any) => ({
    isAuthenticated: state.authentication.isAuthenticated,
    isPageLoading: state.authentication.isPageLoading,
    userData: state.authentication.userData,
    isLoginFailed: state.authentication.isLoginFailed,
    pageMessage: state.authentication.pageMessage,
    isLoginSuccess: state.authentication.isLoginSuccess,
})


export default connect(mapStateToProps)(Login);
